/* eslint-disable no-extra-parens */
export const blockCtaFix = (buffer) => {
    // blogs - no difference in checking only cover document with gate
    // flipbooks - difference

    function setStyle(element, styleObject) {
        for (const property in styleObject) {
            element.style[property] = styleObject[property];
        }
        return element;
    }

    const blockCTA = document.querySelector('.block-cta');
    const ctaWillGateTheVidOrDocOnlyChecked = document.querySelector('.embed-block-body');

    if (blockCTA && !ctaWillGateTheVidOrDocOnlyChecked) {
        const CTAHalfHeight = blockCTA.offsetHeight / 2;
        const main = document.getElementById('item-content');
        const mainContentTop = main.getBoundingClientRect().top + document.body.scrollTop;
        const contentBottom = main.offsetTop + main.offsetHeight;
        const halfScreenHeight = window.innerHeight / 2;
        const middleOfScreen = window.pageYOffset + halfScreenHeight;
        const middleScreenTop = middleOfScreen - CTAHalfHeight;
        const middleScreenBottom = middleOfScreen + CTAHalfHeight;



        if (middleScreenTop < mainContentTop) {

            // before scrolling down it's absolute at the top of the article
            setStyle(blockCTA, {
                position: 'absolute',
                top: '0',
                margin: '0',
                transform: `translate(-50%, ${buffer}px)`,
            });
        } else if (middleScreenBottom > contentBottom) {

            // after you hit the bottom of the article, it's absolute at the bottom
            setStyle(blockCTA, {
                position: 'absolute',
                margin: '0',
                top: contentBottom - blockCTA.offsetHeight - CTAHalfHeight + 'px',
                transform: 'translate(-50%, -50%)',
            });
        } else {

            // while scrolling the article, it's fixed
            setStyle(blockCTA, {
                position: 'fixed',
                transform: `translate(-50%, 0)`,
                top: '',
                margin: '0',
            });
        }
    }
};


// WEBPACK FOOTER //
// ./scriptPartials/blockCtaFix.js